import type { IconDefinition, IconName } from '@fortawesome/free-solid-svg-icons';

const prefix = 'fas';
const iconName = 'alert-mild' as IconName;
const width = 496;
const height = 512;
const ligatures: string[] = [];
const unicode = 'xxxx';
const svgPathData =
  'm 255.64545,121.62497 c -17.66067,0 -31.86887,14.2082 -31.86887,31.86888 v 148.72143 c 0,17.66067 14.2082,31.86887 31.86887,31.86887 17.66067,0 31.86887,-14.2082 31.86887,-31.86887 V 153.49385 c 0,-17.66068 -14.2082,-31.86888 -31.86887,-31.86888 z m 40.15899,286.94506 c 0,-22.17921 -17.97979,-40.15898 -40.15899,-40.15898 -22.1792,0 -40.15899,17.97977 -40.15899,40.15898 0,22.17921 17.97979,40.15898 40.15899,40.15898 22.1792,0 40.15899,-17.97977 40.15899,-40.15898 z';

export const alertMild: IconDefinition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};
